import React from 'react'

import { BaseContent } from '@fourthwall/components'

import Thumbnail from '../../assets/video-thumbnail.png'
import * as S from './Video.styled'

export const Video = () => (
  <S.Container
    href="https://help.fourthwall.com/hc/en-us/articles/31440397820059-How-to-Share-Members-Only-Audio-Content-on-Spotify"
    target="_blank"
  >
    <S.Thumbnail>
      <S.ThumbnailImage src={Thumbnail} />
    </S.Thumbnail>
    <div>
      <div>
        <BaseContent size="small">
          <strong>How to sync Spotify with Fourthwall</strong>
        </BaseContent>
      </div>
    </div>
  </S.Container>
)
